module.exports = __webpack_public_path__ + "img/various-icon-c.a5d8a193.png";